import React from "react";
import { ImagePreview, TableFieldPlaceholderPreview } from "./ElementsPreview";
import IconPreview from "./IconPreview";
import "./Preview.css";
import TabViewRenderer from "./tabviewlib/TabViewRenderer";
import { gridCommonFunction } from "./utils/gridCommonFunction";
import pdfImage from "../../../images/pdf_image.png";
import mailImage from "../../../images/mail_thread.png";

const DetailsviewPreview = ({ detailviewConfig }) => {
  let rowItemElements = [];
  let LayoutArray = [];
  for (let index = 0; index < detailviewConfig?.length; index++) {
    let gridElement = detailviewConfig[index];
    LayoutArray.push(gridElement.grid);
    rowItemElements.push(gridElement.element_config);
  }
  let styleDataForGrid = gridCommonFunction.convertArrayInGridTemplateAreas(LayoutArray);

  return (
    <div className="detailsView_inside_page grid-preview-outer">
      <div style={styleDataForGrid}>
        {rowItemElements.map((colItem, colItemIndexIs) => {
          let styleObject = {
            gridArea: `zino-${colItem?.i || colItem.id}`
          };

          let inline_style = colItem?.inline_style;
          styleObject = { ...styleObject, ...inline_style };
          let class_name = "";
          if (colItem.className) {
            if (typeof colItem.className === "object") {
              class_name = Object.values(colItem.className).join(" ");
            } else {
              class_name = colItem.className;
            }
          }

          if (colItem.hide) {
            return undefined;
          } else {
            switch (colItem.type) {
              case "button":
                return (
                  <div key={colItem.id + colItemIndexIs} style={styleObject}>
                    <button className={class_name ? class_name : "builder_btn_primary preview m_0"}>
                      {colItem.name}
                    </button>
                  </div>
                );
              case "button-group":
                return (
                  <div key={colItem.id + colItemIndexIs} className="d_flex gap_2" style={{ ...styleObject }}>
                    {colItem.button_list.length > 0 ? (
                      colItem.button_list.map((button, index) => (
                        <button key={index} className={class_name ? class_name : "builder_btn_primary preview m_0"}>
                          {button.name}
                        </button>
                      ))
                    ) : (
                      <div>{colItem.display}</div>
                    )}
                  </div>
                );

              case "dropdown":
                return (
                  <div className="builder_dropdown_outer preview" key={colItem.id + colItemIndexIs} style={styleObject}>
                    <select className="builder_input">
                      <option value="">{colItem.name}</option>
                    </select>
                  </div>
                );
              case "form":
                return (
                  <div className="builder_dropdown_outer preview" key={colItem.id + colItemIndexIs} style={styleObject}>
                    <div>{colItem.name}</div>
                  </div>
                );

              case "file_viewer":
              case "file_preview":
                return (
                  <img
                    className="builder_dropdown_outer preview"
                    style={{ ...styleObject, height: "60px", width: "60px" }}
                    src={pdfImage}
                    alt="img"
                    key={colItem.id + colItemIndexIs}
                  />
                );
              case "mail_thread":
                return (
                  <img
                    className="builder_dropdown_outer preview"
                    style={{ ...styleObject, height: "100%", width: "100%" }}
                    src={mailImage}
                    alt="img"
                    key={colItem.id + colItemIndexIs}
                  />
                );
              case "progress-tracker":
                return (
                  <div className="builder_dropdown_outer preview" key={colItem.id + colItemIndexIs} style={styleObject}>
                    <div>{colItem.name}</div>
                  </div>
                );
              case "separator":
                return <hr key={colItem.id + colItemIndexIs} style={styleObject} />;

              case "section":
                return (
                  <div className="preview" key={colItem.id + colItemIndexIs} style={{ ...styleObject }}>
                    <div className={class_name} style={{ height: colItem.height ? `${colItem.height}px` : "100%" }}>
                      <DetailsviewPreview detailviewConfig={colItem.config.layouts} />
                    </div>
                  </div>
                );

              case "timeline":
                return (
                  <div
                    key={colItem.id + colItemIndexIs}
                    className={class_name}
                    style={{ ...styleObject, height: "50px" }}
                  >
                    {colItem.display}
                  </div>
                );

              case "activitycard":
              case "activity-recordsview":
              case "activity-chart":
              case "progress-bar":
                return (
                  <div
                    key={colItem.id + colItemIndexIs}
                    className={class_name}
                    style={{ ...styleObject, height: "50px" }}
                  >
                    {colItem.display}
                  </div>
                );

              case "custom-component":
                return (
                  <div
                    key={colItem.id + colItemIndexIs}
                    className={class_name}
                    style={{ ...styleObject, height: "50px" }}
                  >
                    {colItem.name + " (custom-component)"}
                  </div>
                );

              case "tableview":
                return (
                  <div key={colItem.id + colItemIndexIs} style={{ ...styleObject, overflow: "auto hidden" }}>
                    <table className={class_name} style={inline_style}>
                      <thead>
                        <tr>
                          {colItem.config.headerData.map((column, index) => {
                            return <th key={index}>{column}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {colItem.config.bodyData.map((column, index) => (
                          <tr key={index}>
                            {column.map((item, itemIndex) => {
                              const { className = {}, inline_style = {}, icon } = item;
                              const dynamicClassName = [...Object.values(className)].filter(Boolean).join(" ");

                              return (
                                <td
                                  key={itemIndex}
                                  title={item.data_key}
                                  className={dynamicClassName}
                                  style={{ display: "table-cell", ...inline_style }}
                                >
                                  {icon && <IconPreview icon={icon || ""} />}
                                  {item.data}
                                  {item.data_key.substring(0, 15)}...
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );

              case "tabview":
                return (
                  <div className="dashboard_tabview preview" key={colItem.id + colItemIndexIs} style={styleObject}>
                    <TabViewRenderer configData={colItem.config} />
                  </div>
                );

              case "html":
              case "dynamic-html":
                return colItem.content ? (
                  <div
                    className={`${class_name}`}
                    key={colItem.id + colItemIndexIs}
                    style={styleObject}
                    dangerouslySetInnerHTML={{
                      __html: colItem?.content
                    }}
                  ></div>
                ) : (
                  <div key={colItem.id + colItemIndexIs}>{colItem.display}</div>
                );
              case "variable":
                return colItem.custom_js ? (
                  <div
                    className={`${class_name}`}
                    key={colItem.id + colItemIndexIs}
                    style={styleObject}
                    dangerouslySetInnerHTML={{
                      __html: colItem?.custom_js
                    }}
                  ></div>
                ) : (
                  <div>{colItem.display}</div>
                );

              case "label":
                return (
                  <div
                    className={`fields_align preview ${class_name} `}
                    key={colItem.id + colItemIndexIs}
                    style={styleObject}
                  >
                    {colItem?.icon && <IconPreview icon={colItem.icon || ""} />}
                    <span>{colItem.name}</span>
                  </div>
                );

              case "image":
                return <ImagePreview key={colItem.id + colItemIndexIs} config={colItem} />;

              case "field":
              case "empty":
                if (colItem.field_type === "recordset" || colItem.field_type === "recordset-list") {
                  const numberOfColumns = Number(colItem?.cards_per_row) || 1;
                  const numberOfRows = 2;
                  const renderItems = [...Array(numberOfRows)].map((_, rowIndex) => (
                    <div key={rowIndex} className="d_flex mb_2">
                      {[...Array(numberOfColumns)].map((_, colIndex) => (
                        <div key={colIndex} className="p_3 text_center" style={{ flex: "1", border: "1px solid #ccc" }}>
                          Record {colIndex + 1}
                        </div>
                      ))}
                    </div>
                  ));
                  return <div key={colItem.id + colItemIndexIs}>{renderItems}</div>;
                } else {
                  return (
                    <div
                      key={colItem.id + colItemIndexIs}
                      className={`fields_align preview ${class_name}`}
                      style={styleObject}
                    >
                      <span>
                        <TableFieldPlaceholderPreview config={colItem} />
                      </span>
                    </div>
                  );
                }

              case "spacer":
                return (
                  <div
                    key={colItem.id + colItemIndexIs}
                    style={{ ...styleObject, height: `${colItem?.height || 40}px` }}
                  ></div>
                );

              default:
                return <div key={colItem.id + colItemIndexIs} style={styleObject}></div>;
            }
          }
        })}
      </div>
    </div>
  );
};

export default DetailsviewPreview;
